export var Urls = {
    Register: "account/register",
    Login: "account/login",
    Logout: "account/logout",
    ReloadUser: "account/reloadUser",
    GetBalance: "account/GetBalance",
    ChangePassword: "account/ChangePassword",
    TwoFactorOptions: "account/TwoFactorOptions",
    BeginTwoFactorSetup: "account/BeginTwoFactorSetup",
    ConfirmTwoFactorSetup: "account/ConfirmTwoFactorSetup",
    ValidateTwoFactorCode: "account/ValidateTwoFactorCode",
    SendTwoFactorEmailCode: "account/SendTwoFactorEmailCode",
    ValidateTwoFactorEmailCode: "account/ValidateTwoFactorEmailCode",
    ResetTwoFactor: "account/ResetTwoFactor"
};
